/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PermissionCategoryViewModel } from '../../models/permission-category-view-model';

export interface GetPermissionCategories$Params {
}

export function GetPermissionCategories(http: HttpClient, rootUrl: string, params?: GetPermissionCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionCategoryViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPermissionCategories.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PermissionCategoryViewModel>>;
    })
  );
}

GetPermissionCategories.PATH = '/api/Permissions/GetPermissionCategories';
